import React, { useState, useEffect } from 'react';
import { useTable, useSortBy, useGlobalFilter } from 'react-table';
import { Table, Container, Row, Col, Spinner, Pagination } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import './Table.css';
import ChartCheckbox from '../Dashboard/Tools/ChartCheckbox';

const TableComponentPage4 = ({
  columns,
  data,
  onSelectedRowsChange,
  selectedCheckbox,
  hiddenPagination,
  Pages,
  currentPage,
  onPageChange,
  loading,
  showCheckbox,
  linkColumn,
  linkUrl
  // Add the linkColumn prop here
}) => {
  const [checkedRows, setCheckedRows] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [reset, setReset] = useState(false);
  const [topCheck, setTopCheck] = useState(false);
  const navigate = useNavigate();  // useNavigate hook from react-router-dom for navigation

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy
  );

  useEffect(() => {
    if (onSelectedRowsChange) {
      onSelectedRowsChange(selectedRows);
    }
  }, [selectedRows, onSelectedRowsChange]);

  useEffect(() => {
    setCheckedRows({});
    setSelectedRows([]);
    setTopCheck(false)
  }, [reset, data]);

  const handleCheckboxChange = (rowIndex, rowData) => {
    setCheckedRows((prevState) => {
      const updatedCheckedRows = { ...prevState, [rowIndex]: !prevState[rowIndex] };
      const updatedSelectedRows = Object.keys(updatedCheckedRows)
        .filter(index => updatedCheckedRows[index])
        .map(index => data[index]);

      setSelectedRows(updatedSelectedRows);
      return updatedCheckedRows;
    });
    console.log(checkedRows)
  };

  const handleDeCheckAll = () => {
    setTopCheck(!topCheck);
    if (!topCheck) {
      var mappedObject = {};
      data.forEach((item, index) => {
        mappedObject[index] = true; // Set the key as index and value as true
      });
      setCheckedRows(mappedObject);
      setSelectedRows(data)
    }
    else {
      setSelectedRows([])
      setCheckedRows({});

    }
    console.log(selectedRows)
  };

  const handleNextPage = () => {
    if (currentPage < Pages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  // Function to handle navigation when the linkColumn is clicked
  const handleNavigate = (rowData) => {
    const id = rowData.original[linkColumn]; // Get the value from the specified linkColumn
    navigate(linkUrl + id); // Navigate to the desired URL, adjust this as per your routes
  };

  return (
    <Container className="mb-0 pb-0">
      <Row className='justify-content-end mb-2'>
        {!hiddenPagination ? (
          <Col lg={3} md={4} sm={6}>
            <div className='d-flex align-items-center gap-2'>
              <span style={{ fontSize: "14px", color: "#94a3b8" }}>Show</span>
              <select name="10" id="" style={{
                outline: 'none',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                color: "#94a3b8",
                borderRadius: '3px',
                fontSize: '16px'
              }}>
                <option value="hello">10</option>
              </select>
              <span style={{ fontSize: "14px", color: "#94a3b8" }}>Per Page</span>
            </div>
          </Col>
        ) : (<></>)}
      </Row>
      <div className='table-container'>
        <Table {...getTableProps()} striped bordered hover className='pb-0 mb-2'>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {
                  (showCheckbox == undefined || showCheckbox) ? (
                    <th style={{ maxWidth: 45, backgroundColor: '#292d2e', color: '#f8f9fa', padding: '5px', alignItems: "center" }}>
                      <ChartCheckbox label='' onChange={handleDeCheckAll} initialChecked={topCheck} size='13px' />
                    </th>
                  ) : (
                    <></>
                  )
                }
                {headerGroup.headers.map(column => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className="text-center position-relative"
                    style={{
                      backgroundColor: '#292d2e',
                      color: '#f8f9fa',
                      fontSize: "10px",
                      overflow: 'visible',
                      minWidth: 'max-content',
                      padding: '5px',
                      lineHeight: 'normal',
                      verticalAlign: 'middle',
                      width: `calc((100% - 50px) / ${headerGroup.headers.length})`,
                    }}
                  >
                    {column.render('Header')}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {loading ? (
              <tr>
                <td colSpan={columns.length + 1} className="text-center">
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                </td>
              </tr>
            ) : rows.length > 0 ? (
              rows.map((row, i) => {
                prepareRow(row);
                var isRowChecked = checkedRows[i] || false;
                if (selectedCheckbox) {
                  isRowChecked = selectedCheckbox;
                }
                return (
                  <tr
                    {...row.getRowProps()}
                    className={isRowChecked ? 'checked-col' : ''}
                  >
                    {
                      (showCheckbox == undefined || showCheckbox) ? (
                        <td style={{ maxWidth: 45 }} className='check-table'>
                          <ChartCheckbox
                            initialChecked={isRowChecked}
                            label=''
                            size='13px'
                            onChange={() => handleCheckboxChange(i, row.original)}
                          />
                        </td>
                      ) : (
                        <></>
                      )
                    }
                    {row.cells.map(cell => (
                      <td
                        {...cell.getCellProps()}
                        style={{ textAlign: 'center', cursor: cell.column.id === linkColumn ? 'pointer' : 'default',color: cell.column.id === linkColumn ?'var(--rs-text-link)':'' }}
                        onClick={cell.column.id === linkColumn ? () => handleNavigate(row) : null} // Only attach onClick for the linkColumn
                      >
                        {cell.render('Cell')}
                      </td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length + 1} className="text-center" style={{ backgroundColor: "#fafafa", width: "100%" }}>
                  Empty list
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      {!hiddenPagination && (
        <div className='pagination-table-com'>
          <Pagination>
            <Pagination.Prev onClick={handlePrevPage} disabled={currentPage === 1} />
            {[...Array(Pages).keys()].map(page => (
              <Pagination.Item
                key={page + 1}
                active={page + 1 === currentPage}
                onClick={() => onPageChange(page + 1)}
              >
                {page + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next onClick={handleNextPage} disabled={currentPage === Pages} />
          </Pagination>
        </div>
      )}
    </Container>
  );
};

export default TableComponentPage4;
